<script setup lang="ts">
import { LogIn } from '@lucide/vue'
import type { PortalModule } from './module-registry'
import { useSessionStore } from '@/core/auth/session'
import AppButton from '@/core/ui/AppButton.vue'
import AppBrand from './AppBrand.vue'
import AppNavigation from './AppNavigation.vue'
import AccountMenu from './AccountMenu.vue'

withDefaults(defineProps<{ modules?: PortalModule[] }>(), { modules: () => [] })
const session = useSessionStore()
</script>

<template>
  <header class="app-topbar">
    <div class="pf-container app-topbar__inner">
      <div class="app-topbar__brand"><slot name="nav-trigger" /><AppBrand /></div>
      <AppNavigation :modules="modules" class="app-topbar__navigation" />
      <div class="app-topbar__actions">
        <slot name="actions" />
        <AccountMenu v-if="session.isAuthenticated" />
        <template v-else>
          <span class="app-topbar__hint">开启你的技能成长之旅</span>
          <AppButton variant="primary" size="sm" @click="session.gotoLogin()"><LogIn :size="15" aria-hidden="true" />登录平台</AppButton>
        </template>
      </div>
    </div>
  </header>
</template>

<style scoped>
.app-topbar { position: sticky; top: 0; z-index: 30; border-bottom: 1px solid var(--pf-border); background: var(--pf-surface); }
.app-topbar__inner { display: flex; align-items: center; justify-content: flex-start; gap: 24px; min-height: 78px; }
.app-topbar__brand, .app-topbar__actions { display: flex; align-items: center; gap: 12px; }
.app-topbar__brand { min-width: 0; }
.app-topbar__navigation, .app-topbar__actions { flex-shrink: 0; }
.app-topbar__actions { margin-left: auto; }
.app-topbar__hint { font-size: 12px; color: var(--pf-text-tertiary); }
@media (max-width: 1100px) { .app-topbar__hint { display: none; } }
@media (max-width: 767px) {
  .app-topbar__inner { min-height: 66px; gap: 8px; }
  .app-topbar__brand { gap: 4px; }
  .app-topbar__navigation { display: none; }
  .app-topbar__actions { gap: 4px; }
}
</style>
